import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 

const CustomerAssessment = ({ onCustomerAssessmentChange, dossierData }) => {
  const [profitability, setProfitability] = useState(dossierData.Profitability || "");
  const [growthStage, setGrowthStage] = useState(dossierData["Growth Stage"] || " ");
  const [economicImpact, setEconomicImpact] = useState(dossierData["Current Economic Conditions"] || "");
  const [leadership, setLeadership] = useState(dossierData.Leadership || "");
  const [resourceChanges, setResourceChanges] = useState(dossierData["Change in Resources"] || "");
  const [acquisitionRate, setAcquisitionRate] = useState(dossierData["Customers Acquisition Rate"] || ""); 
  const inputRef = useRef(null);


  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        onCustomerAssessmentChange({
          profitability,
          growthStage, 
          economicImpact,
          leadership,
          resourceChanges,
          acquisitionRate
        });
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [profitability, growthStage, economicImpact, leadership, resourceChanges, acquisitionRate, onCustomerAssessmentChange]);

  const handleProfitabilityChange = (event) => {
    setProfitability(event.target.value);
  };

  const handleGrowthStageChange = (event) => {
    setGrowthStage(event.target.value);
  };

  const handleEconomicImpactChange = (event) => {
    setEconomicImpact(event.target.value);
  };

  const handleLeadershipChange = (event) => {
    setLeadership(event.target.value);
  };

  const handleResourceChangesChange = (value) => {
    setResourceChanges(value);
  };

  const handleAcquisitionRateChange = (value) =>{
    setAcquisitionRate(value);
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#00A0B2" }}>
        Customer Assessment
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Profitability</InputLabel>
            <Select value={profitability} label="Profitability" onChange={handleProfitabilityChange}>
              <MenuItem value="Consistently Profitable">Consistently Profitable</MenuItem>
              <MenuItem value="Seasonally Profitable">Seasonally Profitable</MenuItem>
              <MenuItem value="Yet to Make Profits">Yet to Make Profits</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Growth Stage</InputLabel>
            <Select value={growthStage} label="Growth Stage" onChange={handleGrowthStageChange}>
              <MenuItem value="Growing">Growing</MenuItem>
              <MenuItem value="Has Growth Potential">Has Growth Potential</MenuItem>
              <MenuItem value="Not experiencing growth">Not experiencing growth</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Impact of Current Economic Conditions</InputLabel>
            <Select
              value={economicImpact}
              label="Impact of Current Economic Conditions"
              onChange={handleEconomicImpactChange}
            >
              <MenuItem value="Revenues Declined">Revenues Declined</MenuItem>
              <MenuItem value="Revenue Stable">Revenue Stable</MenuItem>
              <MenuItem value="Revenue Grew">Revenue Grew</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Leadership</InputLabel>
            <Select value={leadership} label="Leadership" onChange={handleLeadershipChange}>
              <MenuItem value="Stable">Stable</MenuItem>
              <MenuItem value="Recent Churn">Recent Churn</MenuItem>
              <MenuItem value="Recent New Leadership">Recent New Leadership</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <div ref={inputRef}>
            <label style={{marginTop:"0.5rem", marginBottom:"1rem"}}>Change in Resources (Additions/Deletions)</label>
            <ReactQuill
              theme="snow"
              value={resourceChanges}
              onChange={handleResourceChangesChange}
              placeholder="Change in Resources (Additions/Deletions)"
            />
          </div>
        </Grid>
        <Grid item xs={12}>
          <div ref={inputRef}>
          <label style={{marginTop:"0.5rem", marginBottom:"1rem"}}>Customers Acquisition Rate</label>
            <ReactQuill
              theme="snow"
              value={acquisitionRate}
              onChange={handleAcquisitionRateChange}
              placeholder="Customers Acquisition Rate"
            />
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerAssessment;